import React, { createContext, useContext, useState, useEffect } from 'react';
import partnerApi, { PARTNER_TOKEN_KEY } from '../api/partnerApi';

const PartnerAuthContext = createContext(null);

export function PartnerAuthProvider({ children }) {
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(PARTNER_TOKEN_KEY);
    if (!token) { setLoading(false); return; }

    partnerApi.get('/me')
      .then((res) => {
        if (res?.success) setPartner(res.data?.partner || res.partner);
      })
      .catch(() => localStorage.removeItem(PARTNER_TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await partnerApi.post('/auth/login', { email, password });
    if (res?.success) {
      localStorage.setItem(PARTNER_TOKEN_KEY, res.token);
      setPartner(res.partner);
      return res;
    }
    throw new Error('Login failed');
  };

  const register = async (data) => {
    const res = await partnerApi.post('/auth/register', data);
    if (res?.success) {
      localStorage.setItem(PARTNER_TOKEN_KEY, res.token);
      setPartner(res.partner);
      return res;
    }
    throw new Error('Registration failed');
  };

  const logout = () => {
    localStorage.removeItem(PARTNER_TOKEN_KEY);
    setPartner(null);
  };

  const refreshPartner = async () => {
    try {
      const res = await partnerApi.get('/me');
      if (res?.success) setPartner(res.data?.partner || res.partner);
    } catch (_) {}
  };

  return (
    <PartnerAuthContext.Provider value={{ partner, loading, login, register, logout, refreshPartner }}>
      {children}
    </PartnerAuthContext.Provider>
  );
}

export function usePartnerAuth() {
  return useContext(PartnerAuthContext);
}
